export default "__VITE_ASSET__BaqWudVS__"